import {
    Box,
    Typography,
} from "@mui/material"
import React from "react"
import ContainerAccordionTableRow from "./ContainerAccordionTableRow"
import Content from "../../../../anwendungskonfigurator/components/Content"

const ARRAYOFFSET = 1
const ACOORDIONOFFSET = 0

const ContainerAccordionTable = ({container, value}) => {
    const rows = value ?? []
    
    const headerWidgets = container.children?.filter((entry) => entry.y === 0)
    const contentWidgets = container.children?.filter(
        (entry) => entry.y === 1,
    )
    
    const detailWidgets = container.children?.filter((entry) => entry.y === 2)
    const effectiveColumnCount = (container?.columncount || 0) + 1
    const gridTemplateColumns = `repeat(${container?.columncount}, 1fr) 40px`
    return (
        <Box>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: gridTemplateColumns,
                    alignItems: "center",
                }}>
                {headerWidgets?.map((widget) => (
                    <Box
                        key={widget.id}
                        height="100%"
                        sx={{
                            gridColumn:
                                widget.x +
                                ARRAYOFFSET +
                                ACOORDIONOFFSET +
                                " /span " +
                                widget.w,
                            gridRow:
                                widget.y + ARRAYOFFSET + " /span " + widget.h,
                        }}>
                        <Content child={widget} />
                    </Box>
                    
                ))}
                <Box
                    bgcolor={"#ffffff"}
                    height="100%"/>
            </Box>
            {rows?.length ? (
                rows.map((row, key) => (
                    <ContainerAccordionTableRow
                        container={container}
                        gridTemplateColumns={gridTemplateColumns}
                        contentWidgets={contentWidgets}
                        detailWidgets={detailWidgets}
                        row={row}
                        rowKey={key}
                        key={key}
                    />
                ))
            ) : (
                <Box
                    padding={2}
                    sx={{
                        gridColumn: 1 + " /span " + effectiveColumnCount,
                        gridRow: 2,
                        textAlign: "center",
                        border: "1px solid #eee",
                    }}>
                    <Typography variant="body1">Keine Einträge</Typography>
                </Box>
            )}
        </Box>
    )
}

export default ContainerAccordionTable
